import * as React from 'react'
import {ReactElement} from 'react'
import {Nullable} from '../../../app/TypeHelpers'
import {StyledDiv} from '../../../styledComponents/StyledTypeDefinitions'
import styled, {css} from 'styled-components'
import {Colors, DispWidthSize, FontSize, FontWeights} from '../../../styledComponents/Constants'
import {ResidentPagePropsSet} from '../../../components/shared/hoc/createResidentPage'
import {isIE} from 'react-device-detect'
import {currentMedia, RenderSwitchByBreakPoint} from '../../../styledComponents/ResponsiveConvenience'
import {NavigateFunction} from 'react-router-dom'

const FOOTER_LINK_URL_MYPAGE: string = '/resident/mypage'
const FOOTER_LINK_URL_CONTACTUS: string = '/resident/contactus'
const FOOTER_LINK_URL_GROUP_LINK: string = 'https://www.haseko.co.jp/hc/company/group.html'
const FOOTER_LINK_URL_PRIVACY: string = 'https://www.haseko.co.jp/hc/privacy.html'
const FOOTER_LINK_URL_POLICY_TERMS: string = '/resident/contents/policyTerms'
const FOOTER_LINK_URL_EXTERNAL_TRANSMISSION: string = '/resident/externalTransmission'

interface Props {
    navigate: NavigateFunction,
    loginedFlg: boolean
    isNoTransitionFlg?: boolean
}

export default class NatResidentFooterAreaComponent extends React.Component<Props> {
    constructor(props: Props & ResidentPagePropsSet) {
        super(props)
    }

    renderFooterLinkArea(): Nullable<ReactElement> {
        if (this.props.isNoTransitionFlg) {
            return null
        }

        const showHomeLink = this.props.loginedFlg

        return <>
            <FooterLinkArea>
                {showHomeLink && <>
                    <FooterBox>
                        <FooterLink onClick={() => {
                            this.props.navigate(FOOTER_LINK_URL_MYPAGE)
                        }}>
                            ホーム
                        </FooterLink>
                    </FooterBox>
                    <LinkSeparater/>
                </>}
                <FooterBox>
                    {(isIE) ?
                        <FooterAnchorLink target={'_blank'} onClick={() => window.open(FOOTER_LINK_URL_CONTACTUS)}>
                            お問い合わせ
                        </FooterAnchorLink> :
                        <FooterAnchorLink href={FOOTER_LINK_URL_CONTACTUS} target={'_blank'} rel={'opener'}>
                            お問い合わせ
                        </FooterAnchorLink>
                    }
                </FooterBox>
                <LinkSeparater/>
                <FooterBox>
                    <FooterLink onClick={() => {
                        window.open(FOOTER_LINK_URL_GROUP_LINK, '_blank')
                    }}>
                        グループリンク
                    </FooterLink>
                </FooterBox>
                <RenderSwitchByBreakPoint
                    over={<LinkSeparater/>}
                    under={showHomeLink ? <br/> : <LinkSeparater/>}
                />
                <FooterBox>
                    <FooterAnchorLink href={FOOTER_LINK_URL_EXTERNAL_TRANSMISSION} target={'_blank'}>
                        利用者情報の外部送信
                    </FooterAnchorLink>
                </FooterBox>
                <RenderSwitchByBreakPoint
                    over={<LinkSeparater/>}
                    under={showHomeLink ? <LinkSeparater/> : <br/>}
                />
                <FooterBox>
                    <FooterLink onClick={() => {
                        window.open(FOOTER_LINK_URL_PRIVACY, '_blank')
                    }}>
                        プライバシーポリシー
                    </FooterLink>
                </FooterBox>
                <LinkSeparater/>
                <FooterBox>
                    <FooterAnchorLink href={FOOTER_LINK_URL_POLICY_TERMS} target={'_blank'}>
                        利用規約
                    </FooterAnchorLink>
                </FooterBox>
            </FooterLinkArea>
        </>
    }

    render(): Nullable<ReactElement> {
        return (
            <StyledFooterArea>
                {this.renderFooterLinkArea()}
                <Copywriter>Copyright © HASEKO Corporation. All Rights Reserved.</Copywriter>
            </StyledFooterArea>
        )
    }
}

const StyledFooterArea: StyledDiv = styled.div`
  background-color: ${Colors.Primary};
  color: ${Colors.Surface};
  font-weight: ${FontWeights.Normal};
  margin-left: auto;
  margin-right: auto;
  max-width: ${DispWidthSize.MaxWidth};
  box-shadow: 6px 0 5px -5px ${Colors.Shadow}, -6px 0 5px -5px ${Colors.Shadow};
`

const FooterLinkArea: StyledDiv = styled.div`
  ${currentMedia.greaterThan('pc')`
    display: flex;
    align-items: center;
  `}
  ${currentMedia.lessThan('sp')`
    text-align: center;
    padding: 5px 0;
  `}
  border-bottom: 1px solid ${Colors.Surface};
`

const FooterBox: StyledDiv = styled.div`
  ${currentMedia.greaterThan('pc')`
    // 各リンクを同じ幅で横いっぱいにする
    flex: 1 1 0;
    height: 38px;
    margin: 5px;
  `}
  ${currentMedia.lessThan('sp')`
    display: inline-block;
  `}
`

const FooterLinkCss = css`
  font-size: ${FontSize.Small};
  color: ${Colors.Surface};
  white-space: nowrap;
  cursor: pointer;

  ${currentMedia.greaterThan('pc')`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
  `}
  ${currentMedia.lessThan('sp')`
    box-sizing: border-box;
    padding: 5px 14px;
  `}
  &:hover {
    background-color: ${Colors.PrimaryComplete};
  }
`

const FooterLink: StyledDiv = styled.div`
  ${FooterLinkCss};
`

const FooterAnchorLink = styled.a`
  ${FooterLinkCss};
  text-decoration: none;
`

const Copywriter: StyledDiv = styled.div`
  text-align: center;
  font-size: ${FontSize.Small};
`

const LinkSeparater = styled.div`
  display: inline-block;
  vertical-align: middle;
  min-width: 1px;
  height: 18px;
  background-color: ${Colors.AccentLight};
`
